import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { createLegoComponent } from '../../core/utils/legoUtils';
import Config from '../../config';
import { getStyledText } from '../../helpers/styled';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

export const Box = withTheme(
  styled.div(
    ({ coreTheme, isLast, isFirst, bordered }) => css`
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
      max-height: 100%;

      padding: 0 ${!isLast ? `${coreTheme.space_2}px` : 0} 0
        ${!isFirst || bordered ? `${coreTheme.space_4}px` : 0};
    `
  )
);

export const Columns = withTheme(styled.div`
  display: flex;
  flex-direction: row;

  min-height: ${props =>
    props.tall
      ? `${props.coreTheme.listItem.minHeightTall}px`
      : `${props.coreTheme.listItem.minHeight}px`};

  ${props => !!props.onClick && `cursor: pointer;`}
`);

export const Column = withTheme(styled.div`
  display: flex;
  flex: ${props => (props.width === 'content' ? 1 : 'none')};
  align-items: ${props => props.coreTheme.listItem.controlAlignItems};
  min-width: 0;
`);

export const Title = withTheme(
  getStyledText('boldBody')(({ coreTheme, maxLine }) => {
    return css`
      overflow: hidden;
      color: ${coreTheme.listItem.colorTextTitle};
      line-height: ${coreTheme.listItem.lineHeight};
      text-overflow: ellipsis;

      ${Config.media.md`
        line-height: ${coreTheme.listItem.lineHeightTitleMD};
      `};

      /* stylelint-disable value-no-vendor-prefix */
      display: -webkit-box;
      /* stylelint-disable property-no-vendor-prefix */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${maxLine};
    `;
  })
);

export const SubTitle = withTheme(
  getStyledText('smallBody', { lineHeight: 'compact' })(
    ({ coreTheme, maxLine }) => {
      return css`
        flex: none;
        overflow: hidden;
        color: ${coreTheme.listItem.colorTextSubtitle};
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${maxLine};
        line-height: ${coreTheme.listItem.lineHeight};

        ${Config.media.md`
        line-height:  ${coreTheme.listItem.lineHeightSubtitleMD};
      `};
      `;
    }
  )
);

export const TagWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const Tag = withTheme(
  styled.span(({ coreTheme }) => {
    return css`
      text-align: center;
      height: ${coreTheme.tag.controlHeight};
      position: absolute;
      bottom: 0;
      background: ${coreTheme.tag.colorBg};
      font-family: ${coreTheme.tag.fontFamily};
      letter-spacing: ${coreTheme.tag.letterSpacing};
      line-height: ${coreTheme.tag.lineHeight};
      color: ${coreTheme.tag.colorText};
      padding: ${coreTheme.tag.padding};
      width: 100%;
      box-sizing: border-box;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;

      ${{
        ...responsiveStyles(
          {
            fontSize: coreTheme.tag.fontSize
          },
          coreTheme
        )
      }}
    `;
  })
);

export const ListItemPointsContainer = withTheme(
  getStyledText('smallBody')(
    () => css`
      display: flex;
      align-items: center;

      svg {
        margin-right: 4px;
      }
    `
  )
);

export const LeftContainer = withTheme(styled.div`
  position: relative;
  min-height: ${props => props.coreTheme.listItem.controlMinHeightBorderless}px;
  min-width: ${props => props.coreTheme.listItem.controlMinWidthBorderless}px;
  border-radius: ${props => props.coreTheme.listItem.borderRadius}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.coreTheme.listItem.colorBg};

  > img {
    width: 100%;
  }

  ${props => {
    if (props.tall) {
      return `
      width: 100%;
    `;
    } else if (props.bordered) {
      return `
      min-height: ${props.coreTheme.listItem.controlMinHeight}px; 
      height: ${props.coreTheme.listItem.controlHeight};
      width: ${props.coreTheme.listItem.controlThumbnailWidth}px;
      border-radius: 0;

      > img {
        height: 100%;
      }
    `;
    } else {
      return `
      min-height: ${props.coreTheme.listItem.controlMinHeightBorderless}px; 
      height: ${props.coreTheme.listItem.controlMinHeightBorderless}px;
      width: ${props.coreTheme.listItem.controlThumbnailBorderlessWidth}px;
      overflow: hidden;
    `;
    }
  }}
`);

export const RightContainer = withTheme(styled.div`
  padding: 0;

  ${props => props.bordered && `padding-right: ${props.coreTheme.space_4}px;`}
`);

export const ListItemThumbnail = createLegoComponent(
  'ListItemThumbnail',
  withTheme(styled.img`
    min-height: ${props => props.coreTheme.listItem.controlMinHeightTall}px;
    min-width: ${props => props.coreTheme.listItem.controlMinWidthTall}px;
    height: ${props => props.coreTheme.listItem.controlWidthHeight};
    width: ${props => props.coreTheme.listItem.controlWidthTall}px !important;
    display: block;
  `)
);

export const ListItemImage = createLegoComponent(
  'ListItemImage',
  withTheme(styled.img`
    height: ${props =>
      props.height ? `${props.height}px` : '100%'} !important;
    width: ${props => (props.width ? `${props.width}px` : '104px')} !important;
    display: block;
  `)
);
